import { useMutation } from '@tanstack/react-query';

import api from 'api';
import { curryPostFunction } from 'api/utils';
import useProjectRoute from 'hooks/useProjectRoute';

const useConfigUpdate = (projectId: string) => {
  const { accountId } = useProjectRoute();

  return useMutation({
    mutationFn: curryPostFunction(api.agentWizardUpdateConfig)({
      accountId,
      projectId,
    }),
  });
};

export default useConfigUpdate;
